import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Signin from "../auth/Signin";

import { AuthService } from "../../services/auth/authService";

const LogIn = () => {
  const navigate = useNavigate();

  // useEffect(() => {
  //   setIsLoading(loading);
  //   console.log("loading", loading);
  // }, [loading]);

  useEffect(() => {
    const checkToken = () => {
      const token = Cookies.get("Token");
      if (token) {
        navigate("/packages");
      } else {
        navigate("/auth-signin");
      }
    };

    checkToken();
  }, [navigate]);

  // if (loading) {
  //   return <Loader />;
  // }

  return (
    <>
      <AuthService>
        <Signin />
        <Outlet />
      </AuthService>
    </>
  );
};

export default LogIn;
